import { useEffect } from 'react';

import { useAppContainerContext } from '../../../../contexts/AppContainerContext';
import { useToasterContext } from '../../../../contexts/ToasterContext';
import { inCustomBreakpoint, useWindowDimensions } from '../../../../hooks/useDimensions';
import { BaseDrawerLayoutProps, default as BaseDrawerLayout } from '../BaseDrawerLayout';
import { MIN_WIDTH_EXPANDABLE } from '../BaseDrawerLayout/BaseDrawerLayout.styles';

export const APP_DRAWER_EXPANDED_WIDTH = '15rem';
export const APP_DRAWER_COLLAPSED_WIDTH = `${77 / 16}rem`;

export type AppDrawerLayoutProps = Partial<BaseDrawerLayoutProps> & Omit<BaseDrawerLayoutProps, 'drawerContent'>;

const AppDrawerLayout = ({ mainContent, ...rest }: AppDrawerLayoutProps) => {
  const { width } = useWindowDimensions();
  const { toasterDrawerIsOpen, setToasterDrawerIsOpen } = useToasterContext();
  const { isDrawerExpanded, setDrawerExpanded } = useAppContainerContext();

  // Handlers
  const handleDrawerOnChange = () => {
    const newValue = !isDrawerExpanded;
    setDrawerExpanded(newValue);
    setToasterDrawerIsOpen(newValue);
  };

  useEffect(() => {
    const isDrawerOpen = inCustomBreakpoint(MIN_WIDTH_EXPANDABLE, width) && isDrawerExpanded;
    if (isDrawerOpen !== toasterDrawerIsOpen) {
      // Update toaster left position if the drawer expanded state is changed during resize
      setToasterDrawerIsOpen(isDrawerOpen);
    }
  }, [width, isDrawerExpanded, toasterDrawerIsOpen, setToasterDrawerIsOpen]);

  return (
    <BaseDrawerLayout
      expandedWidth={APP_DRAWER_EXPANDED_WIDTH}
      collapsedWidth={APP_DRAWER_COLLAPSED_WIDTH}
      mainContent={mainContent}
      isOpen={isDrawerExpanded}
      onChange={handleDrawerOnChange}
      {...rest}
    ></BaseDrawerLayout>
  );
};

export default AppDrawerLayout;
